__turbopack_context__.v({
  "button_container": "regulatory-module-scss-module__2N4Gaa__button_container",
  "container": "regulatory-module-scss-module__2N4Gaa__container",
  "container_margin": "regulatory-module-scss-module__2N4Gaa__container_margin",
  "custom_list": "regulatory-module-scss-module__2N4Gaa__custom_list",
  "hide_li_icon": "regulatory-module-scss-module__2N4Gaa__hide_li_icon",
  "subheading": "regulatory-module-scss-module__2N4Gaa__subheading",
});
